import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";


const useActionButtonStyles = makeStyles((theme: Theme) => createStyles({
    fab: {
        height: "2.75rem",
        width: "2.75rem",
        backgroundColor: "rgba(0, 0, 0, 0.40)",
        color: theme.palette.common.white,
        "&:hover": {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.secondary.light,
        },
        boxShadow: "none",
    },
    fabItem: {
        marginLeft: "0.625rem",
    },
    menu: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
        borderRadius: 8,
    },
    mosaicHeader: {
        fontSize: "16px",
    },
    mosaicListItem: {
        fontSize: "14px",
    },
    active: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.secondary.light,
    },
}));

export default useActionButtonStyles;
